// [NEW FEATURE 10] ActivityFeed — last N entries from /activity_log,
// rendered as a "what happened today" panel on the LiveFeed/Tape page.

import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.js';

const KIND_LABEL = {
  suppression_added: 'Suppression added',
  batch_prepared: 'Batch prepared',
  batch_sent: 'Batch sent',
  sequence_enrolled: 'Sequence enrolled',
  view_minted: 'View minted',
  contacts_uploaded: 'Contacts uploaded',
  scheduled_send_fired: 'Scheduled send fired',
  template_saved: 'Template saved',
  note: 'Note',
};

function fmtRelative(ms) {
  if (!ms) return '—';
  const delta = Date.now() - ms;
  if (delta < 60_000) return `${Math.floor(delta / 1000)}s ago`;
  if (delta < 3600_000) return `${Math.floor(delta / 60_000)}m ago`;
  if (delta < 86400_000) return `${Math.floor(delta / 3600_000)}h ago`;
  return `${Math.floor(delta / 86400_000)}d ago`;
}

export function ActivityFeed({ limit = 20 }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const load = async () => {
    setLoading(true); setErr(null);
    try {
      const { data } = await httpsCallable(functions, 'listActivity')({ limit });
      setItems(data?.items || []);
    } catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [limit]);

  return (
    <div style={{ border: '1px solid var(--rule)', background: 'var(--card)' }}>
      <div className="px-3 py-2 flex items-center justify-between"
           style={{ borderBottom: '1px solid var(--rule)' }}>
        <div className="text-[10px] uppercase tracking-[0.18em]" style={{ color: 'var(--muted)' }}>
          What happened today
        </div>
        <button onClick={load}
          className="text-[9px] uppercase tracking-[0.14em] px-1.5 py-0.5"
          style={{ border: '1px solid var(--rule)', color: 'var(--muted)', background: 'transparent' }}>
          Refresh
        </button>
      </div>
      {loading ? (
        <div className="p-3 text-[11px]" style={{ color: 'var(--muted)' }}>Loading…</div>
      ) : err ? (
        <div className="p-3 text-[11px]" style={{ color: 'var(--negative, #f87171)' }}>{err}</div>
      ) : !items.length ? (
        <div className="p-3 text-[11px]" style={{ color: 'var(--muted)' }}>No activity yet.</div>
      ) : (
        <ul className="divide-y" style={{ borderColor: 'var(--rule)' }}>
          {items.map((it) => (
            <li key={it.id} className="px-3 py-2 text-[11px]"
                style={{ borderTop: '1px solid var(--rule)', color: 'var(--ink)' }}>
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  <span className="text-[9px] uppercase tracking-[0.14em] shrink-0"
                        style={{ color: 'var(--muted)', minWidth: 100 }}>
                    {KIND_LABEL[it.kind] || it.kind}
                  </span>
                  <span className="truncate">{it.label}</span>
                </div>
                <span className="text-[9px] font-mono shrink-0" style={{ color: 'var(--muted)' }}>
                  {fmtRelative(it.created_at_ms)}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ActivityFeed;
